import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { Input } from "antd"
import { useRef } from "react";

// defines
type Props = {
  value: any;
  placeholder: any;
  onChange: (data: any) => void;
};

export default function DatePickerComponent({ value, placeholder, onChange }: Props) {
  const datePickerRef = useRef<any>(null);

  const handleClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.openCalendar();
    }
  };

  return (
      <DatePicker
        value={value}
        ref={datePickerRef}
        className="w-full"
        onChange={(date) => {
          onChange(date?.format());
        }}
        calendar={persian}
        locale={persian_fa}
        render={(value: string, openCalendar: () => void) => {
          // This empty render prevents the default input from showing
          return <Input
            value={value}
            className="w-full"
            onClick={handleClick}
            readOnly
            placeholder={placeholder}
          />;
        }}
      />
  );
}
